import 'babel-polyfill'

import Vue from 'vue'

if(document.getElementById("popup_CONFUSING_BEHAVIOR_app")) {
    var app = new Vue({
        delimiters: ['[[', ']]'],
        el: '#popup_CONFUSING_BEHAVIOR_app',
        data: {
            showRawData: false,
        },
        methods: {
            toggleRawData: function() {
                this.showRawData = !this.showRawData;
            }
        }
    })
}